<div class="flex items-center justify-start">
  <!-- Hidden Input -->
  <input
    type="checkbox"
    hidden
    [formControl]="formControl"
    [formlyAttributes]="field"
    (change)="onInputChange($event)"
  />

  <!-- Custom Checkbox -->
  <button
    type="button"
    class="relative flex min-h-5 min-w-5 cursor-pointer items-center justify-center rounded-md border-2 border-grey-300 bg-white outline-offset-1 select-none group-hover:border-blue-600 focus:outline outline-blue-600 active:shadow-[0px_0px_0px_3px] active:shadow-blue-150"
    [ngClass]="{
      'border-blue-600! bg-blue-600!': formControl.value,
    }"
    [attr.data-test-id]="field.key"
    (click)="toggleState()"
  >
    @if (formControl.value) {
      <svg-icon class="size-4 invert" src="/assets/icons/General/check.svg" />
    }
  </button>
</div>
